var _path, _path2, _circle, _ellipse, _ellipse2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9048 2H9.09521C9.81773 1.99999 10.4005 1.99999 10.8724 2.03855C11.3583 2.07825 11.7851 2.16212 12.18 2.36331C12.8072 2.68289 13.3171 3.19283 13.6367 3.82003C13.8379 4.21489 13.9218 4.64168 13.9615 5.12758C14 5.5995 14 6.18226 14 6.90478V9.09522C14 9.81774 14 10.4005 13.9615 10.8724C13.9218 11.3583 13.8379 11.7851 13.6367 12.18C13.3171 12.8072 12.8072 13.3171 12.18 13.6367C11.7851 13.8379 11.3583 13.9218 10.8724 13.9615C10.4005 14 9.81774 14 9.09522 14H6.90478C6.18226 14 5.5995 14 5.12758 13.9615C4.64168 13.9218 4.21489 13.8379 3.82003 13.6367C3.19283 13.3171 2.68289 12.8072 2.36331 12.18C2.16212 11.7851 2.07825 11.3583 2.03855 10.8724C1.99999 10.4005 1.99999 9.81773 2 9.09521V6.9048C1.99999 6.18227 1.99999 5.5995 2.03855 5.12758C2.07825 4.64168 2.16212 4.21489 2.36331 3.82003C2.68289 3.19283 3.19283 2.68289 3.82003 2.36331C4.21489 2.16212 4.64168 2.07825 5.12758 2.03855C5.5995 1.99999 6.18227 1.99999 6.9048 2ZM5.23616 3.36745C4.83272 3.40041 4.60092 3.46186 4.42535 3.55132C4.04903 3.74307 3.74307 4.04903 3.55132 4.42535C3.46186 4.60092 3.40041 4.83272 3.36745 5.23616C3.33385 5.64739 3.33333 6.1756 3.33333 6.93333V9.06667C3.33333 9.8244 3.33385 10.3526 3.36745 10.7638C3.40041 11.1673 3.46186 11.3991 3.55132 11.5746C3.74307 11.951 4.04903 12.2569 4.42535 12.4487C4.60092 12.5381 4.83272 12.5996 5.23616 12.6326C5.64739 12.6661 6.1756 12.6667 6.93333 12.6667H9.06667C9.8244 12.6667 10.3526 12.6661 10.7638 12.6326C11.1673 12.5996 11.3991 12.5381 11.5746 12.4487C11.951 12.2569 12.2569 11.951 12.4487 11.5746C12.5381 11.3991 12.5996 11.1673 12.6326 10.7638C12.6661 10.3526 12.6667 9.82441 12.6667 9.06667V6.93333C12.6667 6.1756 12.6661 5.64739 12.6326 5.23616C12.5996 4.83272 12.5381 4.60092 12.4487 4.42535C12.2569 4.04903 11.951 3.74307 11.5746 3.55132C11.3991 3.46186 11.1673 3.40041 10.7638 3.36745C10.3526 3.33385 9.82441 3.33333 9.06667 3.33333H6.93333C6.1756 3.33333 5.64739 3.33385 5.23616 3.36745Z",
    fill: "#7799A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33329 6C2.9651 6 2.66663 6.29848 2.66663 6.66667C2.66663 7.03486 2.9651 7.33333 3.33329 7.33333H12.6666C13.0348 7.33333 13.3333 7.03486 13.3333 6.66667C13.3333 6.29848 13.0348 6 12.6666 6H3.33329Z",
    fill: "#7799A1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3334,
    cy: 10.3335,
    r: 1,
    fill: "#7799A1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.33329,
    cy: 2.00016,
    rx: 0.666667,
    ry: 0.666667,
    fill: "#7799A1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.6667,
    cy: 2.00016,
    rx: 0.666666,
    ry: 0.666667,
    fill: "#7799A1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c08ed0da9e820438cdfcffbe7ccf139b.svg";
export { ForwardRef as ReactComponent };